import { Directive, ElementRef, AfterViewInit } from '@angular/core';

declare var vl: any;

@Directive({
    selector: '[appWuAutocompleteDirective]',
    standalone: false
})
export class WuAutocompleteDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    vl.autocomplete.dress(this.elementRef.nativeElement);
  }
}
